import React, { useEffect, useState } from "react"
import "../../../../../App.scss"
import { Modal, Form, Input, Row, Col, Spin, InputNumber, Checkbox } from "antd"

import SelectTypeSim from "src/components/Dropdown/SelectTypeSim"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import WarehouseService from "src/services/WarehouseService"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import { BlockInfoStyle } from "src/pages/ADMIN/HumanResource/styled"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import SelectPackage from "src/components/Dropdown/SelectPackage"
import SelectDiscountType from "src/components/Dropdown/SelectDiscountType"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import PackageDetail from "src/pages/ADMIN/Accounting/Order/component/PackageDetail"
import { SectionCard } from "../../PurchaseReport/Modal/styled"
import { SectionTitle } from "./styled"
import ReportsService from "src/services/ReportService"
import TableCustom from "src/components/Table/CustomTable"

const ModalViewOrder = ({ open, onCancel, recordId }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [simRows, setSimRows] = useState([])
  const [dataRows, setDataRows] = useState([])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [selectedTypes, setSelectedTypes] = useState([])
  const [countryId, setCountryId] = useState(null)
  const [totalDataQuantity, setTotalDataQuantity] = useState(0)
  const [totalAmountAfterDiscount, setTotalAmountAfterDiscount] = useState(0)
  const [discountType, setDiscountType] = useState("percent")
  const [discountValue, setDiscountValue] = useState(0)
  const [note, setNote] = useState(null)
  const [packageId, setPackageId] = useState(null)
  const [detailTableData, setDetailTableData] = useState([])

  useEffect(() => {
    if (open && recordId) {
      fetchDataDetail()
    }
  }, [open, recordId])

  const fetchDataDetail = async () => {
    setLoading(true)
    try {
      if (recordId) {
        const response = await ReportsService.getDetailSale(recordId)
        const detail = response?.success || {}
        const detailSim = detail.sim_details.map((item, index) => ({
          ...item,
          ID: item.ID,
          supplier: item.supplier?.name,
          sim_type: item.sim_type === "1" ? "IoT" : "Travel",
          sim_unit_price: Number(item.sim_unit_price).toLocaleString(),
          type_sim: item.type_sim === "usim" ? "Sim vật lý" : "E-SIM",
          scope: item.scope === "1" ? "Local" : "Roaming",
          package_name: item.package.name,
          total_amount: (
            Number(item.sold_sim_count) * Number(item.sim_unit_price)
          ).toLocaleString(),
          sale_mode:
            item.mode === 0
              ? "Bán theo cài đặt giá bán"
              : item.mode === 1
              ? "Bán theo hoa hồng"
              : "_",
          commission: item.mode === 1 ? Number(item.commission) + "%" : "_",
        }))
        setDetailTableData(detailSim)
        setNote(detail.note || null)
        // Determine order types
        const types = []
        if (detail?.sim_details?.length > 0) {
          types.push("sim")
          const hasPackage = detail.sim_details.some(item => item.package_id)
          if (hasPackage) {
            types.push("data")
          }
        }
        if (detail?.data_details?.length > 0) {
          types.push("data")
        }
        setSelectedTypes(types)

        // Calculate totals
        let totalSimQty = 0
        let totalDataQty = 0
        let totalAmt = 0

        // Calculate SIM totals
        if (detail?.sim_details) {
          detail.sim_details.forEach(sim => {
            const qty = Number(sim.sim_quantity) || 0
            const price = Number(sim.sim_unit_price) || 0
            totalSimQty += qty
            totalAmt += qty * price
          })
        }

        // Calculate DATA totals
        if (detail?.data_details) {
          detail.data_details.forEach(data => {
            const qty = Number(data.data_quantity) || 0
            const price = Number(data.data_unit_price) || 0
            totalDataQty += qty
            totalAmt += qty * price
          })
        }

        // Calculate discount
        const discount = Number(detail.discount) || 0
        const discountType = detail.discount_type || "percent"
        let amountAfterDiscount = totalAmt

        if (discountType === "percent") {
          amountAfterDiscount = totalAmt - (totalAmt * discount) / 100
        } else if (discountType === "fixed") {
          amountAfterDiscount = totalAmt - discount
        }

        if (amountAfterDiscount < 0) amountAfterDiscount = 0

        setTotalQuantity(totalSimQty)
        setTotalDataQuantity(totalDataQty)
        setTotalAmount(totalAmt)
        setTotalAmountAfterDiscount(amountAfterDiscount)
        setDiscountType(discountType)
        setDiscountValue(discount)

        // Set form values
        const initialValues = {
          export_code: detail.export_code,
          customer_id: detail.customer?.fullname || "",
          // customer_id: Number(detail.customer_id),
          country_id: Number(detail.country_id),
          discount_type: detail.discount_type,
          discount: Number(detail.discount),
          // note: detail.note,
          // ...detail?.data_details?.reduce((acc, data, index) => {
          //   acc[`data_network_id${index}`] = Number(data.network_id)
          //   acc[`data_supplier_id${index}`] = Number(data.supplier_id)
          //   acc[`data_quantity${index}`] = data.data_quantity
          //   acc[`data_unit_price${index}`] = data.data_unit_price
          //   return acc
          // }, {}),
          // ...detail?.sim_details?.reduce((acc, sim, index) => {
          //   acc[`network_id${index}`] = Number(sim.network_id)
          //   acc[`supplier_id${index}`] =
          //     sim?.package?.supplier?.name || sim?.supplier?.name || ""
          //   acc[`type_sim${index}`] = sim.type_sim
          //   acc[`sim_type${index}`] = sim.sim_type
          //   acc[`scope${index}`] = sim.scope
          //   acc[`package_id${index}`] = sim?.package?.name || ""
          //   acc[`sim_unit_price${index}`] = sim.sim_unit_price
          //   acc[`sim_quantity${index}`] = sim.sim_quantity
          //   return acc
          // }, {}),
        }

        setCountryId(Number(detail.country_id))
        form.setFieldsValue(initialValues)

        setSimRows(
          Array.from({ length: detail?.sim_details?.length || 0 }, (_, i) => i),
        )
        setDataRows(
          Array.from(
            { length: detail?.data_details?.length || 0 },
            (_, i) => i,
          ),
        )

        // Set package ID if exists
        if (detail?.sim_details?.[0]?.package_id) {
          setPackageId(detail.sim_details[0].package_id)
        }
      }
    } catch (error) {
      console.error("Lỗi:", error)
    } finally {
      setLoading(false)
    }
  }
  const columns = [
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      key: "supplier",
      align: "center",
    },
    {
      title: "Loại sim",
      dataIndex: "type_sim",
      key: "type_sim",
      align: "center",
    },
    {
      title: "Local/Roaming",
      dataIndex: "scope",
      key: "scope",
      align: "center",
    },
    {
      title: "Loại hình sim",
      dataIndex: "sim_type",
      key: "sim_type",
      align: "center",
    },
    {
      title: "Gói cước",
      dataIndex: "package_name",
      key: "package_name",
      align: "center",
    },

    {
      title: "Đơn giá (VNĐ)",
      dataIndex: "sim_unit_price",
      key: "sim_unit_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Số lượng",
      dataIndex: "sold_sim_count",
      key: "sold_sim_count",
      align: "center",
    },
    // {
    //   title: "Cách bán",
    //   dataIndex: "sale_mode",
    //   key: "sale_mode",
    //   align: "center",
    // },
    // {
    //   title: "Chiết khấu",
    //   dataIndex: "commission",
    //   key: "commission",
    //   align: "center",
    // },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ]
  // supplier: item.supplier?.name,
  //         sim_type: item.sim_type === "1" ? "Iot" : "Travel",
  //         sim_unit_price: Number(item.sim_unit_price).toLocaleString(),
  //         type_sim: item.type_sim === "usim" ? "Sim vật lý" : "E-SIM",
  //         scope: item.scope === "1" ? "Local" : "Roaming",
  //         package_name: item.package.name,
  //         total_amout : Number(item.sold_sim_count) * Number(item.sim_unit_price)
  return (
    <Modal
      open={open}
      title="Chi tiết báo cáo phần bán"
      onCancel={() => {
        form.resetFields()
        setTotalQuantity(0)
        setTotalAmount(0)
        setTotalDataQuantity(0)
        setTotalAmountAfterDiscount(0)
        setSelectedTypes([])
        setNote(null)
        setPackageId(null)
        onCancel()
      }}
      width={1400}
      confirmLoading={loading}
      destroyOnClose={true}
      footer={null}
    >
      <Spin spinning={loading}>
        {/* <Form.Item label="Loại đơn hàng">
          <Checkbox.Group
            options={[
              { label: "Sim", value: "sim" },
              { label: "Data", value: "data" },
            ]}
            value={selectedTypes}
            disabled={true}
          />
        </Form.Item> */}

        <Form layout="vertical" form={form}>
          <div style={{ position: "relative" }}>
            {packageId && (
              <div
                style={{
                  position: "absolute",
                  top: -60,
                  right: 80,
                  width: "320px",
                  height: "120px",
                  zIndex: 1200,
                }}
              >
                {/* <PackageDetail  id={packageId} /> */}
              </div>
            )}
            <Row gutter={16}>
              {/* <Col span={4}>
                <Form.Item label="Khách hàng"> */}
              {/* <SelectCustomer
                    disabled={true}
                    type={"LEADER"}
                    placeholder={"Chọn khách hàng"}
                    level={0}
                  /> */}
              {/* <span>{form.getFieldValue("customer_id")}</span> */}
              {/* </Form.Item>
              </Col> */}
              {/* <Col span={4}>
                <Form.Item name="discount_type" label="Loại chiết khấu">
                  <SelectDiscountType disabled={true} />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="discount" label="Chiết khấu">
                  <InputNumber
                    placeholder="Chiết khấu"
                    style={{ width: "100%" }}
                    disabled={true}
                  />
                </Form.Item>
              </Col> */}

              <Col span={24}>
                <Row gutter={16}>
                  <Col span={6} style={{ marginTop: 38 }}>
                    <strong>Khách hàng: </strong>{" "}
                    {form.getFieldValue("customer_id")}
                  </Col>
                  {selectedTypes.includes("sim") && (
                    <Col span={4} style={{ marginTop: 38 }}>
                      <strong>Tổng số lượng sim: </strong> {totalQuantity}
                    </Col>
                  )}
                  {/* {selectedTypes.includes("data") &&
                    !selectedTypes.includes("sim") && (
                      <Col span={5} style={{ marginTop: 38 }}>
                        <strong>Tổng dung lượng data: </strong>
                        {totalDataQuantity}GB
                      </Col>
                    )} */}
                  <Col span={8} style={{ marginTop: 38 }}>
                    <strong>Tổng tiền đơn hàng: </strong>
                    {totalAmount.toLocaleString()}
                  </Col>
                  {/* <Col span={8} style={{ marginTop: 38 }}>
                    <strong>Tổng tiền sau chiết khấu: </strong>
                    {totalAmountAfterDiscount.toLocaleString()}
                  </Col> */}
                </Row>
              </Col>
            </Row>
          </div>

          {selectedTypes.includes("sim") && (
            <SectionCard>
              <SectionTitle>Thông tin đơn hàng SIM</SectionTitle>
              <TableCustom
                isPrimary
                columns={columns}
                dataSource={detailTableData}
                pagination={false}
                // pagination={{
                //   current: pagination.current,
                //   pageSize: pagination.pageSize,
                //   total: pagination.total,
                //   showSizeChanger: true,
                //   pageSizeOptions: ["10", "20", "50", "100"],
                // }}
                // onChange={handleTableChange}
                // footerLeft={<div className="d-flex mt-20" />}
                widthScroll={1200}
                textEmpty="Không có dữ liệu!"
                scroll={{ x: "max-content" }}
                loading={loading}
              />
            </SectionCard>
          )}

          {selectedTypes.includes("data") && !selectedTypes.includes("sim") && (
            <SectionCard>
              <SectionTitle>Thông tin đơn hàng DATA</SectionTitle>
              <BlockInfoStyle>
                <div style={{ marginBottom: 16 }}>
                  <Row gutter={16}>
                    <Col span={5}>
                      <strong>Nhà mạng</strong>
                    </Col>
                    <Col span={5}>
                      <strong>Dung lượng Data (GB)</strong>
                    </Col>
                    <Col span={5}>
                      <strong>Đơn giá</strong>
                    </Col>
                    <Col span={4}>
                      <strong>Tổng tiền:</strong>
                    </Col>
                  </Row>
                </div>

                {dataRows.map((row, index) => (
                  <div key={index} style={{ marginBottom: 16 }}>
                    <Row gutter={16}>
                      <Col span={5}>
                        <Form.Item name={`data_network_id${index}`}>
                          <SelectCarrier
                            disabled={true}
                            countryId={countryId}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item name={`data_quantity${index}`}>
                          <InputNumber
                            style={{ width: "100%" }}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item name={`data_unit_price${index}`}>
                          <InputNumber
                            style={{ width: "100%" }}
                            formatter={value =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={4} style={{ marginTop: 0 }}>
                        <strong>
                          {(
                            (form.getFieldValue(`data_quantity${index}`) || 0) *
                            (form.getFieldValue(`data_unit_price${index}`) || 0)
                          ).toLocaleString()}
                          VNĐ
                        </strong>
                      </Col>
                    </Row>
                  </div>
                ))}
              </BlockInfoStyle>
            </SectionCard>
          )}

          {note && (
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="note" label="Ghi chú">
                  <Input.TextArea placeholder="Ghi chú" disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalViewOrder
